import endpointVersion from '@/helpers/endpoint-version';
import store from '@/store';
import axios from 'axios';
const MIGRATION_MODE = 1;
export async function validate360User(login, password) {
    const tokenV3 = store.state.auth.tokenV3;
    return await axios({
        method: 'POST',
        url: '/auth/validateCRM360',
        baseURL: endpointVersion('v3'),
        headers: { Authorization: `Bearer ${tokenV3}` },
        params: {
            login,
            password,
            mode: MIGRATION_MODE,
        },
    }).then(response => response.data);
}
export async function create360User(userPayload) {
    const { id, email, token } = userPayload;
    return await axios({
        method: 'POST',
        url: '/user/createUserCRM360',
        baseURL: endpointVersion('v3'),
        headers: { Authorization: `Bearer ${token}` },
        params: {
            id,
            email,
            mode: MIGRATION_MODE,
        },
    }).then(response => response?.data);
}
